module.exports = __webpack_public_path__ + "img/user-circle.8a1ce5ec.svg";